export default "__VITE_ASSET__CwIFlyGa__"